export default function SvgSprite() {
  return (
    <svg style={{ display: 'none' }} xmlns="http://www.w3.org/2000/svg">
      <symbol id="logo" viewBox="0 0 204 61" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M74.468 6.693v6.694l5.77-3.35V3.35l-5.77 3.343z"
          fill="#1E78D2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M74.468 6.693L68.69 3.35v6.687l5.778 3.363V6.693z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M80.238 3.35l-5.77 3.343L68.69 3.35 74.468 0l5.77 3.35z"
          fill="#F02D5A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M190.869 21.56c.669-.527 1.428-1.099 2.275-1.716.89-.62 1.817-1.182 2.777-1.684.97-.514 1.982-.941 3.026-1.276a10.132 10.132 0 0 1 3.025-.492 1.861 1.861 0 0 1 1.557.58c.36.6.521 1.3.458 1.998a10.175 10.175 0 0 1-.153 1.653 14.124 14.124 0 0 1-.458 1.914 10.07 10.07 0 0 1-.794 1.87 8.037 8.037 0 0 1-1.099 1.563l-10.754-.638v16.226h4.156v5.66h-16.543v-5.66h3.909V22.792h-3.725v-5.704h12.076v4.415l.267.058zm-26.928-5.149c2.889 0 5.2.481 6.933 1.442a10.624 10.624 0 0 1 3.973 3.618 12.801 12.801 0 0 1 1.805 4.754c.274 1.6.417 3.22.425 4.843v3.07h-19.244c-.038 2.551.491 4.431 1.589 5.64 1.097 1.208 3.053 1.822 5.866 1.844a21.895 21.895 0 0 0 4.639-.492 29.156 29.156 0 0 0 4.583-1.41l1.836 5.15a22.57 22.57 0 0 1-6.139 2.271c-2.06.44-4.16.667-6.266.676a17.308 17.308 0 0 1-7.29-1.32A11.57 11.57 0 0 1 152.202 43a12.444 12.444 0 0 1-2.275-4.97 26.942 26.942 0 0 1-.636-5.794c.015-1.767.228-3.527.636-5.245a14.578 14.578 0 0 1 2.288-5.15 12.727 12.727 0 0 1 4.493-3.898 15.007 15.007 0 0 1 7.233-1.532zm-.032 5.922a5.536 5.536 0 0 0-2.606.574 5.917 5.917 0 0 0-1.811 1.493 6.418 6.418 0 0 0-1.113 2.067 9.62 9.62 0 0 0-.425 2.368h11.306a10.859 10.859 0 0 0-.28-2.463 6.068 6.068 0 0 0-.864-2.061 4.34 4.34 0 0 0-1.621-1.436 5.62 5.62 0 0 0-2.586-.542zm-30.863 19.142a6.547 6.547 0 0 0 2.263-.396 4.455 4.455 0 0 0 1.951-1.474 8.563 8.563 0 0 0 1.411-2.973c.405-1.624.589-3.297.547-4.97a17.198 17.198 0 0 0-.458-4.384 6.578 6.578 0 0 0-1.271-2.636 4.098 4.098 0 0 0-1.907-1.276 8.113 8.113 0 0 0-2.383-.338 9.323 9.323 0 0 0-3.419.734c-1.045.396-2.03.932-2.93 1.595v14.357c.896.519 1.849.93 2.841 1.225 1.084.35 2.216.53 3.355.536zM114.17 55.276h4.157V22.85h-4.157v-5.704h12.159v2.7l.12.063a13.06 13.06 0 0 1 2.136-1.404A15.092 15.092 0 0 1 131 17.49a19.55 19.55 0 0 1 2.447-.638c.715-.135 1.44-.208 2.167-.217a12.793 12.793 0 0 1 5.834 1.231 9.929 9.929 0 0 1 3.756 3.19 13.356 13.356 0 0 1 2.015 4.722 26.1 26.1 0 0 1 .636 5.743 29.958 29.958 0 0 1-.636 6.502 14.206 14.206 0 0 1-2.199 5.156 10.652 10.652 0 0 1-4.004 3.369 13.465 13.465 0 0 1-6.019 1.231 22.335 22.335 0 0 1-3.813-.402 15.744 15.744 0 0 1-4.334-1.442v9.36h4.449V61H114.17v-5.724zm-13.816-13.801a6.517 6.517 0 0 0 2.256-.396 4.446 4.446 0 0 0 1.957-1.474 8.559 8.559 0 0 0 1.405-2.973c.408-1.624.592-3.296.546-4.97a17.152 17.152 0 0 0-.457-4.384 6.675 6.675 0 0 0-1.271-2.636 4.163 4.163 0 0 0-1.907-1.276 8.183 8.183 0 0 0-2.383-.338 9.304 9.304 0 0 0-3.42.734 12.329 12.329 0 0 0-2.936 1.595v14.357c.897.516 1.85.927 2.841 1.225a11.15 11.15 0 0 0 3.369.536zM81.44 55.295h4.156V22.85H81.44v-5.704h12.158v2.7l.12.063a13.106 13.106 0 0 1 2.142-1.404 14.879 14.879 0 0 1 2.415-1.014 19.496 19.496 0 0 1 2.441-.638 12.623 12.623 0 0 1 2.18-.198c2.008-.06 4.003.355 5.821 1.212a9.94 9.94 0 0 1 3.757 3.19 13.271 13.271 0 0 1 2.021 4.722 26.1 26.1 0 0 1 .635 5.743 29.482 29.482 0 0 1-.674 6.502 14.07 14.07 0 0 1-2.199 5.156 10.558 10.558 0 0 1-4.004 3.369c-1.883.869-3.94 1.29-6.012 1.231a22.247 22.247 0 0 1-3.813-.402 15.802 15.802 0 0 1-4.341-1.442v9.36h4.449V61H81.44v-5.704zM67.165 22.85v-5.704h11.58v24.17h4.334v5.105a13.59 13.59 0 0 1-3.419 1.014c-1.11.206-2.234.32-3.362.339-2.199 0-3.75-.453-4.64-1.353-.89-.9-1.366-2.329-1.41-4.288V22.85h-3.083zM35.23 47.218V8.99h-4.03V3.35h12.52v16.494a22.554 22.554 0 0 1 5.085-2.552 15.154 15.154 0 0 1 4.92-.887c1.722-.074 3.439.262 5.007.983a7.717 7.717 0 0 1 2.93 2.514 8.8 8.8 0 0 1 1.38 3.375c.224 1.16.343 2.34.355 3.522v14.574h4.271V46.4a13.777 13.777 0 0 1-3.45.982c-1.1.188-2.21.29-3.325.307a6.892 6.892 0 0 1-3.273-.638 4.715 4.715 0 0 1-1.798-1.596 5.116 5.116 0 0 1-.77-1.99 12.88 12.88 0 0 1-.152-1.838V28.433c0-1.923-.305-3.293-.915-4.11-.636-.816-1.767-1.225-3.483-1.225a9.927 9.927 0 0 0-3.451.702 16.503 16.503 0 0 0-3.33 1.723v21.695h-8.491zM6.108 34.998V39.657a16.788 16.788 0 0 0 4.34 1.277c1.334.21 2.68.323 4.03.338a13.7 13.7 0 0 0 3.972-.492 7.063 7.063 0 0 0 2.542-1.276 4.695 4.695 0 0 0 1.424-1.856c.28-.66.427-1.37.432-2.087a4.41 4.41 0 0 0-.667-2.495 5.581 5.581 0 0 0-1.862-1.716 14.044 14.044 0 0 0-2.81-1.232 59.516 59.516 0 0 0-3.578-1.008 46.814 46.814 0 0 1-5.504-1.672 17.361 17.361 0 0 1-4.334-2.329c-1.19-.875-2.175-2-2.885-3.299a9.474 9.474 0 0 1-1.03-4.58 12.164 12.164 0 0 1 1.163-5.431A11.304 11.304 0 0 1 4.608 7.81a15.28 15.28 0 0 1 5.04-2.482 22.712 22.712 0 0 1 6.419-.861c2.24.016 4.476.21 6.686.58 2.29.343 4.51 1.059 6.571 2.119v9.5h-6.228c0-.823 0-1.633-.032-2.411-.032-.779 0-1.596 0-2.419a12.999 12.999 0 0 0-3.298-.81 27.35 27.35 0 0 0-3.42-.242c-2.444 0-4.237.51-5.376 1.53a5.033 5.033 0 0 0-1.71 3.938 3.763 3.763 0 0 0 .636 2.176 5.728 5.728 0 0 0 1.74 1.595c.882.539 1.825.967 2.81 1.276 1.119.364 2.415.734 3.877 1.104 1.754.485 3.483 1.02 5.192 1.595a17.765 17.765 0 0 1 4.557 2.233 10.908 10.908 0 0 1 3.178 3.51 10.53 10.53 0 0 1 1.22 5.315 12.502 12.502 0 0 1-1.22 5.685 10.604 10.604 0 0 1-3.483 3.988 15.855 15.855 0 0 1-5.497 2.336 30.99 30.99 0 0 1-7.207.772 47.66 47.66 0 0 1-7.665-.639A27.642 27.642 0 0 1 0 44.87v-4.907-4.965h6.108z"
          fill="currentColor"
        />
      </symbol>

      {/* <!-- Social --> */}
      <symbol id="social-facebook" viewBox="0 0 16 31">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M10.453 10.333V7.356c0-1.343.297-2.023 2.383-2.023h2.617v-5h-4c-5 0-7 3.336-7 7v3h-4v5h4v15h6v-15h4.406l.594-5h-5"
        />
      </symbol>
      <symbol id="social-instagram" viewBox="0 0 27 27">
        <g fill="currentColor" fillRule="evenodd">
          <path d="M13.469.333c-3.53 0-3.973.015-5.36.078-1.384.063-2.329.283-3.156.604a6.372 6.372 0 0 0-2.302 1.5 6.372 6.372 0 0 0-1.5 2.303C.83 5.644.611 6.589.547 7.973.484 9.36.47 9.803.47 13.333c0 3.53.015 3.973.078 5.36.063 1.384.283 2.329.604 3.155.333.855.777 1.58 1.5 2.303a6.372 6.372 0 0 0 2.302 1.5c.827.32 1.772.54 3.156.604 1.387.063 1.83.078 5.36.078 3.53 0 3.973-.015 5.36-.078 1.384-.063 2.329-.283 3.155-.604a6.371 6.371 0 0 0 2.303-1.5 6.372 6.372 0 0 0 1.5-2.303c.32-.826.54-1.771.604-3.155.063-1.387.078-1.83.078-5.36 0-3.53-.015-3.973-.078-5.36-.063-1.384-.283-2.329-.605-3.155a6.372 6.372 0 0 0-1.499-2.303 6.371 6.371 0 0 0-2.303-1.5c-.826-.32-1.771-.54-3.155-.604-1.387-.063-1.83-.078-5.36-.078m0 2.342c3.471 0 3.882.014 5.253.076 1.267.058 1.956.27 2.414.448.607.236 1.04.517 1.495.972.455.455.736.888.972 1.495.178.458.39 1.146.448 2.414.062 1.37.076 1.782.076 5.253s-.014 3.882-.076 5.253c-.058 1.268-.27 1.956-.448 2.414a4.028 4.028 0 0 1-.972 1.495 4.027 4.027 0 0 1-1.495.972c-.458.178-1.147.39-2.414.448-1.37.062-1.782.076-5.253.076s-3.883-.014-5.253-.076c-1.268-.058-1.956-.27-2.414-.448a4.027 4.027 0 0 1-1.495-.972A4.03 4.03 0 0 1 3.335 21c-.178-.458-.39-1.146-.448-2.414-.062-1.37-.076-1.782-.076-5.253s.014-3.882.076-5.253c.058-1.268.27-1.956.448-2.414.236-.607.517-1.04.972-1.495A4.028 4.028 0 0 1 5.802 3.2c.458-.178 1.146-.39 2.414-.448 1.37-.062 1.782-.076 5.253-.076" />
          <path d="M13.469 6.333a7 7 0 1 0 0 14 7 7 0 0 0 0-14m0 11.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9m8.7-11.4a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0" />
        </g>
      </symbol>
      <symbol id="social-telegram" viewBox="0 0 32 28">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M29.161.978c1.501-.595 3.052.74 2.686 2.313l-5.414 23.237a1 1 0 0 1-1.567.578l-7.777-5.725-4.101 3.808a1 1 0 0 1-1.632-.426l-2.83-8.757-6.978-2.161c-.901-.28-.95-1.537-.073-1.885L29.161.978zM12.952 17.827L29.63 3.006l-19.541 12.75 2 7.25.863-5.18z"
        />
      </symbol>
      <symbol id="social-youtube" viewBox="0 0 31 22">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M29.794 5.385s-.293-2.067-1.192-2.978c-1.141-1.195-2.42-1.201-3.006-1.27C21.398.833 15.1.833 15.1.833h-.013s-6.297 0-10.495.304c-.586.069-1.865.075-3.006 1.27C.687 3.318.394 5.385.394 5.385s-.3 2.428-.3 4.855v2.176c0 2.428.3 4.855.3 4.855s.293 2.068 1.192 2.978c1.141 1.195 2.64 1.157 3.308 1.283 2.4.23 10.2.301 10.2.301s6.304-.01 10.502-.313c.586-.07 1.865-.076 3.006-1.271.899-.91 1.192-2.978 1.192-2.978s.3-2.427.3-4.855V10.24c0-2.427-.3-4.855-.3-4.855zm-17.797 9.889l-.002-8.429 8.107 4.23-8.105 4.199z"
        />
      </symbol>

      {/* <!-- Elements --> */}
      <symbol id="arrow" viewBox="0 0 10 6">
        <path
          d="M4.99989 6L5.42224 5.58193L10 1.12257L9.1553 0L5 4.0491L0.844705 0L0 1.12257L4.57776 5.58193L4.99989 6Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </symbol>
      <symbol id="checkmark" viewBox="0 0 14 10" fill="none">
        <path
          d="M12.3334 1L5.00008 8.33333L1.66675 5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="instagram" viewBox="0 0 48 48">
        <path
          d="M24.0001 0C17.482 0 16.6647 0.0276254 14.1049 0.144424C11.5503 0.260936 9.80566 0.66668 8.27908 1.26001C6.70087 1.87325 5.36246 2.69389 4.02814 4.02812C2.69391 5.36245 1.87325 6.70087 1.26001 8.27908C0.66668 9.80566 0.260952 11.5503 0.14444 14.1048C0.0276407 16.6647 0 17.482 0 24C0 30.518 0.0276407 31.3353 0.14444 33.8952C0.260952 36.4497 0.66668 38.1943 1.26001 39.7209C1.87325 41.2991 2.69391 42.6376 4.02814 43.9719C5.36246 45.3061 6.70087 46.1267 8.27908 46.7401C9.80566 47.3333 11.5503 47.7391 14.1049 47.8556C16.6647 47.9724 17.482 48 24.0001 48C30.518 48 31.3353 47.9724 33.8951 47.8556C36.4497 47.7391 38.1943 47.3333 39.7209 46.7401C41.2991 46.1267 42.6375 45.3061 43.9719 43.9719C45.3061 42.6376 46.1267 41.2991 46.7401 39.7209C47.3333 38.1943 47.7391 36.4497 47.8556 33.8952C47.9724 31.3353 48 30.518 48 24C48 17.482 47.9724 16.6647 47.8556 14.1048C47.7391 11.5503 47.3333 9.80566 46.7401 8.27908C46.1267 6.70087 45.3061 5.36245 43.9719 4.02812C42.6375 2.69389 41.2991 1.87325 39.7209 1.26001C38.1943 0.66668 36.4497 0.260936 33.8951 0.144424C31.3353 0.0276254 30.518 0 24.0001 0ZM24.0001 4.32431C30.4083 4.32431 31.1674 4.3488 33.6981 4.46426C36.038 4.57096 37.3088 4.96194 38.1545 5.29062C39.2748 5.726 40.0743 6.24607 40.9141 7.08595C41.7539 7.92574 42.274 8.72523 42.7094 9.84549C43.038 10.6912 43.429 11.962 43.5357 14.3019C43.6512 16.8326 43.6757 17.5917 43.6757 24C43.6757 30.4083 43.6512 31.1674 43.5357 33.6981C43.429 36.038 43.038 37.3088 42.7094 38.1545C42.274 39.2748 41.7539 40.0743 40.9141 40.914C40.0743 41.7539 39.2748 42.274 38.1545 42.7094C37.3088 43.0381 36.038 43.429 33.6981 43.5357C31.1677 43.6512 30.4087 43.6757 24.0001 43.6757C17.5913 43.6757 16.8324 43.6512 14.3019 43.5357C11.962 43.429 10.6912 43.0381 9.84549 42.7094C8.72523 42.274 7.92573 41.7539 7.08594 40.914C6.24615 40.0743 5.726 39.2748 5.29062 38.1545C4.96194 37.3088 4.57096 36.038 4.46426 33.6981C4.3488 31.1674 4.32431 30.4083 4.32431 24C4.32431 17.5917 4.3488 16.8326 4.46426 14.3019C4.57096 11.962 4.96194 10.6912 5.29062 9.84549C5.726 8.72523 6.24605 7.92574 7.08594 7.08595C7.92573 6.24607 8.72523 5.726 9.84549 5.29062C10.6912 4.96194 11.962 4.57096 14.3019 4.46426C16.8326 4.3488 17.5918 4.32431 24.0001 4.32431ZM24.0001 11.6757C17.1934 11.6757 11.6757 17.1934 11.6757 24C11.6757 30.8066 17.1934 36.3243 24.0001 36.3243C30.8066 36.3243 36.3243 30.8066 36.3243 24C36.3243 17.1934 30.8066 11.6757 24.0001 11.6757ZM24.0001 32C19.5817 32 16 28.4183 16 24C16 19.5817 19.5817 16 24.0001 16C28.4183 16 32 19.5817 32 24C32 28.4183 28.4183 32 24.0001 32ZM39.6913 11.1888C39.6913 12.7794 38.4018 14.0687 36.8112 14.0687C35.2207 14.0687 33.9313 12.7794 33.9313 11.1888C33.9313 9.59817 35.2207 8.30872 36.8112 8.30872C38.4018 8.30872 39.6913 9.59817 39.6913 11.1888Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </symbol>
      <symbol id="delivery-reliability" viewBox="0 0 88 73">
        <rect width="67" height="52" fill="#3E51B2" />
        <path d="M25 0H44V23L34.5 17L25 23V0Z" fill="#FF5786" />
        <circle cx="67" cy="52" r="21" fill="#FF5786" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M67 31V52H46C46 40.4021 55.4023 31 67 31Z"
          fill="#451F68"
        />
        <path
          d="M63.273 61L57 54.6667L59.0905 52.556L63.273 56.7787L77.9095 42L80 44.112L63.273 61Z"
          fill="#F1F6F9"
        />
      </symbol>
      <symbol id="delivery-speed" viewBox="0 0 104 61">
        <path
          d="M33.1935 28.3586L6.18994 35.8957L41.2907 13.2784L43.9932 22.4899L74.3406 7.56361L75.8562 0L3.03108 4.53711L0 51.8148H8.05981C15.5 51.7454 13.1707 51.8148 17.5 51.8148C21.824 51.8148 20.5 51.8148 26.8132 51.8148H31.3279C39 51.7454 37.676 51.7454 42 51.7454C46.324 51.7454 43.9932 51.7454 50.076 51.8148H70.9276L72.8246 25.0261L34.989 38.3996L33.1935 28.3586ZM104 34.4111L99.358 31.7384V31.7965L86.4708 32.3564L87.059 22.696L98.5049 21.9143L98.6055 21.1801L77.3782 7.94916L74.5 51.7454L79.6992 51.8141C86.4708 51.8148 85.568 51.8148 89.5 51.8148C93.4318 51.8148 90.5 51.8148 97.2497 51.8141H100.837L100.832 51.7454H103.253L104 34.4111Z"
          fill="#3E51B2"
        />
        <circle cx="89" cy="52" r="9" fill="#FF5786" />
        <circle cx="53" cy="52" r="9" fill="#FF5786" />
        <circle cx="18" cy="52" r="9" fill="#FF5786" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M61.998 51.8147C61.8994 46.9297 57.9092 43 53 43C48.1143 43 44.1387 46.8931 44.0039 51.7461C45.7129 51.7485 45.2891 51.7603 50.0762 51.8147H61.998ZM26.998 51.8147C26.8994 46.9297 22.9092 43 18 43C13.0938 43 9.10547 46.9253 9.00195 51.8062C12.8574 51.7727 13.6289 51.7834 14.5928 51.7969C15.2051 51.8052 15.8945 51.8147 17.5 51.8147H26.8135H26.998ZM97.998 51.8142C97.8994 46.9294 93.9082 43 89 43C84.0918 43 80.1006 46.9294 80.002 51.8142L89.5 51.8147L97.25 51.8142H97.998Z"
          fill="#451F68"
        />
      </symbol>
      <symbol id="delivery-friendliness" viewBox="0 0 94 77">
        <rect width="67" height="52" fill="#3E51B2" />
        <rect width="67" height="10" fill="#FF5786" />
        <path
          d="M53.4448 33.1857C53.466 31.671 55.0979 30.7288 56.4203 31.4678L89.5373 49.9749C91.1035 50.8502 90.8141 53.1856 89.0816 53.652L71.4444 58.4005C71.1172 58.4886 70.8177 58.6584 70.5741 58.894L56.3029 72.693C55.024 73.9296 52.888 73.0061 52.9129 71.2272L53.4448 33.1857Z"
          fill="#FF5786"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M67 37.3804V52H53.1816L53.4443 33.1858C53.4658 31.6712 55.0977 30.7288 56.4199 31.4678L67 37.3804Z"
          fill="#451F68"
        />
        <circle cx="6" cy="5" r="2" fill="#E5E5E5" />
        <circle cx="12" cy="5" r="2" fill="#E5E5E5" />
        <circle cx="18" cy="5" r="2" fill="#E5E5E5" />
      </symbol>
      <symbol id="delivery-economy" viewBox="0 0 67 67">
        <circle cx="22.3333" cy="22.3333" r="22.3333" fill="#3E51B2" />
        <circle cx="44.6663" cy="44.6666" r="22.3333" fill="#FF5786" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44.667 22.3333C44.667 34.6677 34.668 44.6667 22.333 44.6667C22.333 32.3323 32.332 22.3333 44.667 22.3333Z"
          fill="#451F68"
        />
      </symbol>
      <symbol id="ic-search" viewBox="0 0 16 16">
        <path
          d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M14.0001 14.0001L11.1001 11.1001"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="ic-ava" viewBox="0 0 36 36">
        <path
          d="M26 27V25C26 23.9391 25.5786 22.9217 24.8284 22.1716C24.0783 21.4214 23.0609 21 22 21H14C12.9391 21 11.9217 21.4214 11.1716 22.1716C10.4214 22.9217 10 23.9391 10 25V27"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M18 17C20.2091 17 22 15.2091 22 13C22 10.7909 20.2091 9 18 9C15.7909 9 14 10.7909 14 13C14 15.2091 15.7909 17 18 17Z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <circle
          cx="18"
          cy="18"
          r="17"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
        />
      </symbol>
      <symbol id="ic-plus" viewBox="0 0 16 16">
        <path
          d="M8 3.33325V12.6666"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.3335 8H12.6668"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="ic-clipboard" viewBox="0 0 16 16">
        <path
          d="M10.6665 2.66675H11.9998C12.3535 2.66675 12.6926 2.80722 12.9426 3.05727C13.1927 3.30732 13.3332 3.64646 13.3332 4.00008V13.3334C13.3332 13.687 13.1927 14.0262 12.9426 14.2762C12.6926 14.5263 12.3535 14.6667 11.9998 14.6667H3.99984C3.64622 14.6667 3.30708 14.5263 3.05703 14.2762C2.80698 14.0262 2.6665 13.687 2.6665 13.3334V4.00008C2.6665 3.64646 2.80698 3.30732 3.05703 3.05727C3.30708 2.80722 3.64622 2.66675 3.99984 2.66675H5.33317"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M10.0002 1.33325H6.00016C5.63197 1.33325 5.3335 1.63173 5.3335 1.99992V3.33325C5.3335 3.70144 5.63197 3.99992 6.00016 3.99992H10.0002C10.3684 3.99992 10.6668 3.70144 10.6668 3.33325V1.99992C10.6668 1.63173 10.3684 1.33325 10.0002 1.33325Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </symbol>
      <symbol id="ic-clock" viewBox="0 0 16 16" fill="none">
        <path
          d="M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 4v4l2.667 1.333"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="ic-package" viewBox="0 0 16 16">
        <path
          d="M8.62302 1.13586L14.223 3.73684C14.4562 3.8445 14.6525 4.01048 14.7898 4.2161C14.9271 4.42172 14.9999 4.65883 15 4.90077V11.0976C14.9999 11.3395 14.9271 11.5767 14.7898 11.7823C14.6525 11.9879 14.4562 12.1539 14.223 12.2615L8.62302 14.8625C8.42851 14.9529 8.21401 15 7.99652 15C7.77902 15 7.56452 14.9529 7.37002 14.8625L1.77003 12.2615C1.53702 12.1525 1.34146 11.9851 1.2054 11.7783C1.06935 11.5715 0.998218 11.3335 1.00003 11.0911V4.90077C1.00017 4.65883 1.07297 4.42172 1.21023 4.2161C1.34749 4.01048 1.54378 3.8445 1.77703 3.73684L7.37702 1.13586C7.57061 1.0465 7.78384 1 8.00002 1C8.21619 1 8.42943 1.0465 8.62302 1.13586V1.13586Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M1.54688 4.10669L8.00021 7.33336L14.4535 4.10669"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M8 14.6999V7.3999"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 2.5L11 5.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="ic-send" viewBox="0 0 16 16">
        <path
          d="M14.6668 1.33325L7.3335 8.66659"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6668 1.33325L10.0002 14.6666L7.3335 8.66659L1.3335 5.99992L14.6668 1.33325Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </symbol>
      <symbol id="ic-map-pin" viewBox="0 0 16 16">
        <path
          d="M14 6.72727C14 11.1818 8 15 8 15C8 15 2 11.1818 2 6.72727C2 5.20831 2.63214 3.75155 3.75736 2.67748C4.88258 1.60341 6.4087 1 8 1C9.5913 1 11.1174 1.60341 12.2426 2.67748C13.3679 3.75155 14 5.20831 14 6.72727Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M8 8.66675C9.10457 8.66675 10 7.77132 10 6.66675C10 5.56218 9.10457 4.66675 8 4.66675C6.89543 4.66675 6 5.56218 6 6.66675C6 7.77132 6.89543 8.66675 8 8.66675Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </symbol>
      <symbol id="ic-truck" viewBox="0 0 16 16">
        <path
          d="M11 2H1V11H11V2Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M11 5H13.2857L15 7.25V11H11V5Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M3.66667 14.3333C4.58714 14.3333 5.33333 13.5871 5.33333 12.6667C5.33333 11.7462 4.58714 11 3.66667 11C2.74619 11 2 11.7462 2 12.6667C2 13.5871 2.74619 14.3333 3.66667 14.3333Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M12.3337 14.3333C13.2541 14.3333 14.0003 13.5871 14.0003 12.6667C14.0003 11.7462 13.2541 11 12.3337 11C11.4132 11 10.667 11.7462 10.667 12.6667C10.667 13.5871 11.4132 14.3333 12.3337 14.3333Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </symbol>
      <symbol id="ic-check-circle" viewBox="0 0 16 16">
        <path
          d="M14.6668 7.38674V8.00007C14.666 9.43769 14.2005 10.8365 13.3397 11.988C12.4789 13.1394 11.269 13.9817 9.8904 14.3893C8.51178 14.797 7.03834 14.748 5.68981 14.2498C4.34128 13.7516 3.18993 12.8308 2.40747 11.6248C1.62501 10.4188 1.25336 8.99212 1.34795 7.55762C1.44254 6.12312 1.9983 4.75762 2.93235 3.66479C3.8664 2.57195 5.12869 1.81033 6.53096 1.4935C7.93322 1.17668 9.40034 1.32163 10.7135 1.90674"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M14.6667 2.66675L8 9.34008L6 7.34008"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </symbol>
      <symbol id="ic-bookmark" viewBox="0 0 16 16">
        <path
          d="M12.6668 14L8.00016 10.6667L3.3335 14V3.33333C3.3335 2.97971 3.47397 2.64057 3.72402 2.39052C3.97407 2.14048 4.31321 2 4.66683 2H11.3335C11.6871 2 12.0263 2.14048 12.2763 2.39052C12.5264 2.64057 12.6668 2.97971 12.6668 3.33333V14Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </symbol>
      <symbol id="ic-credit-card" viewBox="0 0 16 16">
        <path
          d="M13.7273 2H2.27273C1.56982 2 1 2.61561 1 3.375V11.625C1 12.3844 1.56982 13 2.27273 13H13.7273C14.4302 13 15 12.3844 15 11.625V3.375C15 2.61561 14.4302 2 13.7273 2Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M1 5H15"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M1 8H15"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </symbol>
      <symbol id="ic-settings" viewBox="0 0 16 16">
        <path
          d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M12.7091 9.90909C12.6244 10.101 12.5991 10.3139 12.6365 10.5204C12.674 10.7268 12.7724 10.9173 12.9191 11.0673L12.9573 11.1055C13.0756 11.2237 13.1695 11.364 13.2335 11.5185C13.2976 11.673 13.3305 11.8387 13.3305 12.0059C13.3305 12.1732 13.2976 12.3388 13.2335 12.4933C13.1695 12.6478 13.0756 12.7882 12.9573 12.9064C12.8391 13.0247 12.6987 13.1186 12.5442 13.1826C12.3897 13.2467 12.2241 13.2796 12.0568 13.2796C11.8896 13.2796 11.7239 13.2467 11.5694 13.1826C11.4149 13.1186 11.2746 13.0247 11.1564 12.9064L11.1182 12.8682C10.9682 12.7215 10.7777 12.6231 10.5713 12.5856C10.3649 12.5482 10.1519 12.5735 9.96 12.6582C9.77178 12.7388 9.61126 12.8728 9.4982 13.0435C9.38513 13.2143 9.32445 13.4143 9.32364 13.6191V13.7273C9.32364 14.0648 9.18955 14.3885 8.95086 14.6272C8.71218 14.8659 8.38846 15 8.05091 15C7.71336 15 7.38964 14.8659 7.15096 14.6272C6.91227 14.3885 6.77818 14.0648 6.77818 13.7273V13.67C6.77325 13.4594 6.70508 13.2551 6.58251 13.0837C6.45994 12.9123 6.28865 12.7818 6.09091 12.7091C5.89897 12.6244 5.68606 12.5991 5.47963 12.6365C5.27319 12.674 5.0827 12.7724 4.93273 12.9191L4.89455 12.9573C4.77634 13.0756 4.63598 13.1695 4.48147 13.2335C4.32696 13.2976 4.16135 13.3305 3.99409 13.3305C3.82683 13.3305 3.66122 13.2976 3.50671 13.2335C3.35221 13.1695 3.21184 13.0756 3.09364 12.9573C2.9753 12.8391 2.88143 12.6987 2.81738 12.5442C2.75333 12.3897 2.72036 12.2241 2.72036 12.0568C2.72036 11.8896 2.75333 11.7239 2.81738 11.5694C2.88143 11.4149 2.9753 11.2746 3.09364 11.1564L3.13182 11.1182C3.27852 10.9682 3.37694 10.7777 3.41437 10.5713C3.4518 10.3649 3.42653 10.1519 3.34182 9.96C3.26115 9.77178 3.12721 9.61126 2.95648 9.4982C2.78575 9.38513 2.58568 9.32445 2.38091 9.32364H2.27273C1.93518 9.32364 1.61146 9.18955 1.37277 8.95086C1.13409 8.71218 1 8.38846 1 8.05091C1 7.71336 1.13409 7.38964 1.37277 7.15096C1.61146 6.91227 1.93518 6.77818 2.27273 6.77818H2.33C2.54063 6.77325 2.74491 6.70508 2.91628 6.58251C3.08765 6.45994 3.21818 6.28865 3.29091 6.09091C3.37562 5.89897 3.40089 5.68606 3.36346 5.47963C3.32603 5.27319 3.22761 5.0827 3.08091 4.93273L3.04273 4.89455C2.92439 4.77634 2.83052 4.63598 2.76647 4.48147C2.70242 4.32696 2.66945 4.16135 2.66945 3.99409C2.66945 3.82683 2.70242 3.66122 2.76647 3.50671C2.83052 3.35221 2.92439 3.21184 3.04273 3.09364C3.16093 2.9753 3.3013 2.88143 3.4558 2.81738C3.61031 2.75333 3.77593 2.72036 3.94318 2.72036C4.11044 2.72036 4.27605 2.75333 4.43056 2.81738C4.58507 2.88143 4.72543 2.9753 4.84364 3.09364L4.88182 3.13182C5.0318 3.27852 5.22228 3.37694 5.42872 3.41437C5.63515 3.4518 5.84806 3.42653 6.04 3.34182H6.09091C6.27913 3.26115 6.43965 3.12721 6.55271 2.95648C6.66578 2.78575 6.72646 2.58568 6.72727 2.38091V2.27273C6.72727 1.93518 6.86136 1.61146 7.10005 1.37277C7.33873 1.13409 7.66245 1 8 1C8.33755 1 8.66127 1.13409 8.89995 1.37277C9.13864 1.61146 9.27273 1.93518 9.27273 2.27273V2.33C9.27354 2.53477 9.33422 2.73484 9.44729 2.90557C9.56035 3.0763 9.72087 3.21024 9.90909 3.29091C10.101 3.37562 10.3139 3.40089 10.5204 3.36346C10.7268 3.32603 10.9173 3.22761 11.0673 3.08091L11.1055 3.04273C11.2237 2.92439 11.364 2.83052 11.5185 2.76647C11.673 2.70242 11.8387 2.66945 12.0059 2.66945C12.1732 2.66945 12.3388 2.70242 12.4933 2.76647C12.6478 2.83052 12.7882 2.92439 12.9064 3.04273C13.0247 3.16093 13.1186 3.3013 13.1826 3.4558C13.2467 3.61031 13.2796 3.77593 13.2796 3.94318C13.2796 4.11044 13.2467 4.27605 13.1826 4.43056C13.1186 4.58507 13.0247 4.72543 12.9064 4.84364L12.8682 4.88182C12.7215 5.0318 12.6231 5.22228 12.5856 5.42872C12.5482 5.63515 12.5735 5.84806 12.6582 6.04V6.09091C12.7388 6.27913 12.8728 6.43965 13.0435 6.55271C13.2143 6.66578 13.4143 6.72646 13.6191 6.72727H13.7273C14.0648 6.72727 14.3885 6.86136 14.6272 7.10005C14.8659 7.33873 15 7.66245 15 8C15 8.33755 14.8659 8.66127 14.6272 8.89995C14.3885 9.13864 14.0648 9.27273 13.7273 9.27273H13.67C13.4652 9.27354 13.2652 9.33422 13.0944 9.44729C12.9237 9.56035 12.7898 9.72087 12.7091 9.90909V9.90909Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </symbol>
      <symbol id="ic-logout" fill="none" viewBox="0 0 16 16">
        <path
          d="M6 14H3.333A1.334 1.334 0 0 1 2 12.667V3.333A1.333 1.333 0 0 1 3.333 2H6M10.667 11.333L14 8l-3.333-3.333M14 8H6"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="ic-trash" viewBox="0 0 16 16">
        <path
          d="M2 4H3.33333H14"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M5.3335 3.99998V2.66665C5.3335 2.31302 5.47397 1.97389 5.72402 1.72384C5.97407 1.47379 6.31321 1.33331 6.66683 1.33331H9.3335C9.68712 1.33331 10.0263 1.47379 10.2763 1.72384C10.5264 1.97389 10.6668 2.31302 10.6668 2.66665V3.99998M12.6668 3.99998V13.3333C12.6668 13.6869 12.5264 14.0261 12.2763 14.2761C12.0263 14.5262 11.6871 14.6666 11.3335 14.6666H4.66683C4.31321 14.6666 3.97407 14.5262 3.72402 14.2761C3.47397 14.0261 3.3335 13.6869 3.3335 13.3333V3.99998H12.6668Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M6.6665 7.33331V11.3333"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M9.3335 7.33331V11.3333"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </symbol>
      <symbol id="empty-box" viewBox="0 0 153 153">
        <path
          d="M0 146.433L0 38.2L11.297 4.35336C12.1647 1.75358 14.6008 9.72914e-06 17.3448 9.72914e-06H19.1139L19.125 2.55771e-07L51 1.84724e-07V19.1C51 22.6162 53.8542 25.4667 57.375 25.4667H95.625C99.1458 25.4667 102 22.6162 102 19.1V7.10476e-08L133.875 0L133.886 9.72908e-06L135.655 9.72914e-06C138.399 9.72914e-06 140.835 1.75358 141.703 4.35336L153 38.2L153 82.7674C153 82.7935 153 82.8196 153 82.8457L153 70.0333V146.433C153 149.95 150.146 152.8 146.625 152.8H6.375C2.85418 152.8 0 149.95 0 146.433ZM6.71984 38.2H12.75V20.1332L6.71984 38.2ZM19.125 38.2H44.625V63.6667C44.625 67.1829 47.4792 70.0333 51 70.0333H102C105.521 70.0333 108.375 67.1829 108.375 63.6667V38.2H133.875V6.36667H108.375V19.1C108.375 26.1324 102.667 31.8333 95.625 31.8333H57.375C50.3334 31.8333 44.625 26.1324 44.625 19.1V6.36667H19.125V38.2ZM140.25 38.2H146.28L140.25 20.1332V38.2ZM38.25 44.5667H6.375V146.433H146.625V44.5667H114.75V63.6667C114.75 70.6991 109.042 76.4 102 76.4H51C43.9584 76.4 38.25 70.6991 38.25 63.6667V44.5667Z"
          fill="currentColor"
        />
        <path
          d="M100.21 91.5248C98.8097 90.6248 96.9097 91.0248 96.0097 92.4248C94.9097 94.1248 93.1097 95.1248 91.0097 95.1248C89.0097 95.1248 87.1097 94.1248 86.1097 92.4248C85.2097 91.0248 83.3097 90.5248 81.9097 91.5248C80.5097 92.4248 80.0097 94.3248 81.0097 95.7248C83.2097 99.2248 87.0097 101.225 91.1097 101.225C95.3097 101.225 99.0097 99.1248 101.31 95.7248C102.01 94.3248 101.61 92.4248 100.21 91.5248Z"
          fill="currentColor"
        />
        <path
          d="M63.01 101.225C67.21 101.225 70.91 99.1255 73.21 95.7255C74.11 94.3255 73.71 92.4255 72.31 91.5255C70.91 90.6255 69.01 91.0255 68.11 92.4255C67.01 94.1255 65.21 95.1255 63.11 95.1255C61.11 95.1255 59.21 94.1255 58.21 92.4255C57.31 91.0255 55.41 90.6255 54.01 91.5255C52.61 92.4255 52.21 94.3255 53.11 95.7255C55.11 99.2255 58.91 101.225 63.01 101.225Z"
          fill="currentColor"
        />
        <path
          d="M90.7097 121.425L89.4097 120.625C87.9097 119.625 85.3097 119.625 83.8097 120.625L81.9097 121.825C81.8097 121.825 81.8097 121.825 81.7097 121.825L79.8097 120.625C78.3097 119.625 75.7097 119.625 74.2097 120.625L72.3097 121.825C72.2097 121.825 72.2097 121.825 72.1097 121.825L70.2097 120.625C68.7097 119.625 66.1097 119.625 64.6097 120.625L63.3097 121.425C62.0097 122.225 61.7097 123.925 62.5097 125.125C63.3097 126.425 65.0097 126.725 66.2097 125.925L67.3097 125.225C67.4097 125.225 67.4097 125.225 67.5097 125.225L69.4097 126.425C70.2097 126.925 71.2097 127.125 72.2097 127.125C73.2097 127.125 74.2097 126.925 75.0097 126.425L76.9097 125.225C77.0097 125.225 77.0097 125.225 77.1097 125.225L79.0097 126.425C80.5097 127.425 83.1097 127.425 84.6097 126.425L86.5097 125.225C86.6097 125.225 86.6097 125.225 86.7097 125.225L87.8097 125.925C89.1097 126.725 90.7097 126.325 91.5097 125.125C92.3097 123.925 91.9097 122.225 90.7097 121.425Z"
          fill="currentColor"
        />
        <path
          d="M53.9142 101.202C53.7039 100.933 53.2833 100.933 53.0729 101.202L49.7779 106.056C47.9551 108.685 49.4974 112.461 52.7224 112.933C52.9327 113 53.2131 113 53.4936 113C53.774 113 53.9843 113 54.2648 112.933C57.5598 112.461 59.0321 108.753 57.2093 106.056L53.9142 101.202Z"
          fill="currentColor"
        />
      </symbol>
      <symbol id="ellipsis" viewBox="0 0 15 3">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm6 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM13.5 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
          fill="currentColor"
        />
      </symbol>
      <symbol id="help-preview-zoom" viewBox="0 0 24 24" fill="none">
        <path
          d="M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM21 21l-4.35-4.35"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="chevron-down" viewBox="0 0 10 6" fill="none">
        <path
          d="M1 1l4 4 4-4"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="parcel-ghost" viewBox="0 0 625 92">
        <g fill="none" fillRule="evenodd">
          <rect
            fill="#A2B0BA"
            fillRule="nonzero"
            opacity=".2"
            x="31"
            y="72"
            width="111"
            height="20"
            rx="3"
          />
          <rect
            fill="#A2B0BA"
            fillRule="nonzero"
            opacity=".2"
            x="189"
            y="72"
            width="229"
            height="20"
            rx="3"
          />
          <rect
            fill="#A2B0BA"
            fillRule="nonzero"
            opacity=".2"
            x="488"
            y="52"
            width="117"
            height="40"
            rx="3"
          />
          <rect
            fill="#A2B0BA"
            fillRule="nonzero"
            opacity=".2"
            x="31"
            y="52"
            width="79"
            height="11"
            rx="3"
          />
          <rect
            fill="#A2B0BA"
            fillRule="nonzero"
            opacity=".2"
            x="189"
            y="52"
            width="85"
            height="11"
            rx="3"
          />
          <rect
            fill="#ECEFF1"
            fillRule="nonzero"
            x="32"
            y="3"
            width="99"
            height="23"
            rx="11.5"
          />
          <circle
            fill="#ECEFF1"
            fillRule="nonzero"
            cx="372.5"
            cy="14.5"
            r="14.5"
          />
          <circle
            fill="#ECEFF1"
            fillRule="nonzero"
            cx="411.5"
            cy="14.5"
            r="14.5"
          />
          <path
            d="M592 14.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm6 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm4.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
            fill="#ECEFF1"
          />
          <path d="M0 33.5h625" stroke="#EDEEF2" />
        </g>
      </symbol>

      <symbol id="parcel-ghost-mobile" viewBox="0 0 240 148">
        <g fill="none" fillRule="evenodd">
          <path
            d="M227 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm6 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm4.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
            fill="#ECEFF1"
          />
          <circle fill="#ECEFF1" fillRule="nonzero" cx="172" cy="46" r="12" />
          <circle fill="#ECEFF1" fillRule="nonzero" cx="200" cy="46" r="12" />
          <circle fill="#ECEFF1" fillRule="nonzero" cx="228" cy="46" r="12" />
          <path d="M0 24.5h240" stroke="#EDEEF2" />
          <rect
            fill="#A2B0BA"
            fillRule="nonzero"
            opacity=".2"
            x="1"
            width="44"
            height="12"
            rx="3"
          />
          <rect
            fill="#A2B0BA"
            fillRule="nonzero"
            opacity=".2"
            x="1"
            y="71"
            width="44"
            height="12"
            rx="3"
          />
          <rect
            fill="#A2B0BA"
            fillRule="nonzero"
            opacity=".2"
            x="1"
            y="88"
            width="170"
            height="16"
            rx="3"
          />
          <rect
            fill="#A2B0BA"
            fillRule="nonzero"
            opacity=".2"
            x="1"
            y="115"
            width="44"
            height="12"
            rx="3"
          />
          <rect
            fill="#A2B0BA"
            fillRule="nonzero"
            opacity=".2"
            x="1"
            y="132"
            width="170"
            height="16"
            rx="3"
          />
          <rect
            fill="#A2B0BA"
            fillRule="nonzero"
            opacity=".2"
            x="184"
            y="132"
            width="56"
            height="16"
            rx="3"
          />
          <rect
            fill="#A2B0BA"
            fillRule="nonzero"
            opacity=".2"
            x="74"
            width="64"
            height="12"
            rx="3"
          />
          <rect
            fill="#A2B0BA"
            fillRule="nonzero"
            opacity=".2"
            x="1"
            y="35"
            width="144"
            height="23"
            rx="11.5"
          />
        </g>
      </symbol>

      <symbol id="help-circle" viewBox="0 0 16 16" fill="none">
        <g clipPath="url(#help-cricle--clip)">
          <path
            d="M8 14.667A6.667 6.667 0 1 0 8 1.333a6.667 6.667 0 0 0 0 13.334z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.017 6.142a2 2 0 0 1 3.924.384c.097 1.33-1.85 2.14-1.85 2.14"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="8.5" cy="10.5" r=".5" fill="currentColor" />
        </g>
        <defs>
          <clipPath id="help-cricle--clip">
            <path fill="#fff" d="M0 0h16v16H0z" />
          </clipPath>
        </defs>
      </symbol>

      <symbol id="clipboard-copy" viewBox="0 0 16 16" fill="none">
        <path
          d="M13.333 6h-6C6.597 6 6 6.597 6 7.333v6c0 .737.597 1.334 1.333 1.334h6c.737 0 1.334-.597 1.334-1.334v-6c0-.736-.597-1.333-1.334-1.333z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.333 10h-.666a1.333 1.333 0 01-1.333-1.333v-6a1.333 1.333 0 011.333-1.334h6A1.333 1.333 0 0110 2.667v.666"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol id="close" viewBox="0 0 24 24">
        <path
          d="M18 6L6 18"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 6L18 18"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol viewBox="0 0 14 15" id="trashcan" fill="none">
        <path
          d="M1.1817 3.8544H2.47465M2.47465 3.8544H12.8182M2.47465 3.8544L2.47476 12.9051C2.47476 13.248 2.61098 13.5768 2.85346 13.8193C3.09593 14.0618 3.4248 14.198 3.76771 14.198H10.2324C10.5753 14.198 10.9042 14.0618 11.1467 13.8193C11.3892 13.5768 11.5254 13.248 11.5254 12.9051V3.85445L2.47465 3.8544ZM4.41418 3.85445V2.5615C4.41418 2.21859 4.5504 1.88972 4.79287 1.64725C5.03535 1.40478 5.36421 1.26855 5.70712 1.26855H8.29302C8.63593 1.26855 8.96479 1.40478 9.20727 1.64725C9.44974 1.88972 9.58596 2.21859 9.58596 2.5615V3.85445M5.70698 7.08679V10.9656M8.2931 7.08679V10.9656"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
      <symbol viewBox="0 0 15 3" id="dots" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 1.5C3 2.32843 2.32843 3 1.5 3C0.671573 3 0 2.32843 0 1.5C0 0.671573 0.671573 0 1.5 0C2.32843 0 3 0.671573 3 1.5ZM9 1.5C9 2.32843 8.32843 3 7.5 3C6.67157 3 6 2.32843 6 1.5C6 0.671573 6.67157 0 7.5 0C8.32843 0 9 0.671573 9 1.5ZM13.5 3C14.3284 3 15 2.32843 15 1.5C15 0.671573 14.3284 0 13.5 0C12.6716 0 12 0.671573 12 1.5C12 2.32843 12.6716 3 13.5 3Z"
          fill="currentColor"
        />
      </symbol>
      <symbol viewBox="0 0 24 24" id="pencil" fill="none">
        <path
          d="M13.2599 3.59924L5.04985 12.2892C4.73985 12.6192 4.43985 13.2692 4.37985 13.7192L4.00985 16.9592C3.87985 18.1292 4.71985 18.9292 5.87985 18.7292L9.09985 18.1792C9.54985 18.0992 10.1799 17.7692 10.4899 17.4292L18.6999 8.73924C20.1199 7.23924 20.7599 5.52924 18.5499 3.43924C16.3499 1.36924 14.6799 2.09924 13.2599 3.59924Z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.8901 5.05078C12.3201 7.81078 14.5601 9.92078 17.3401 10.2008"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 22H21"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </symbol>
    </svg>
  )
}
